import React from 'react';
import { BadgeStyled } from 'components/BadgeCustom/BadgeCustom.styled';

export const BadgeCustom = ({ text = 'new', ...props }) => {
  return <BadgeStyled {...props}>{text}</BadgeStyled>;
};
